import { combineReducers } from "@reduxjs/toolkit";
import {
  getMyPurchasesReducer,
  getMyCoursesReducer,
  getUpcomingCoursesReducer,
  getDiscountsReducer,
  createDiscountReducer,
  deleteDiscountReducer,
} from "./slices";

const instructorCourseReducer = combineReducers({
  myCourses: getMyCoursesReducer,
  myPurchases: getMyPurchasesReducer,
  upcomingCourses: getUpcomingCoursesReducer,
  discounts: getDiscountsReducer,
  createDiscount: createDiscountReducer,
  deleteDiscount: deleteDiscountReducer,
});

export default instructorCourseReducer;
